import { get } from 'svelte/store';
import { page } from '$app/stores';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function injectDiscounts(price: string | number | undefined, productId?: string) {
  if(/*!productId || */!price) return price

  const p = Number(price)
  const discount = get(page)?.data?.activeDiscount?.percent

  if(!discount) return p

  return Math.round( ((p * (1 - discount)) + 0.01) * 100 ) / 100 
}